import { useLanguage } from "@/contexts/LanguageContext";
import postFulltrui from "@/assets/PostFulltrui.png";
import emailFulltrui from "@/assets/EmailFulltrui.png";

const EmailIllustration = () => {
  const { language } = useLanguage();

  const illustration = language === "is" ? postFulltrui : emailFulltrui;

  return (
    <div className="max-w-7xl mx-auto">
      <img 
        src={illustration} 
        alt={language === "is" ? "PóstFulltrúi" : "Email Assistant"}
        className="w-full h-auto"
      />
    </div>
  );
};

export default EmailIllustration;
